import { HStack, Icon, Text } from '@chakra-ui/react'
import { IconType } from 'react-icons'

export function SectionHeading({
  icon,
  children,
  textStyle = 'labelXs',
  color = 'colorPalette.fg',
}: {
  icon: IconType
  children: string
  textStyle?: string
  color?: string
}) {
  return (
    <HStack align={'center'} color={color} gap={2}>
      <Icon as={icon} boxSize={4} />
      <Text fontWeight={textStyle !== 'labelXs' ? 'semibold' : undefined} textStyle={textStyle}>
        {children}
      </Text>
    </HStack>
  )
}
